import { escapeShellFrame } from './app/common/utilities/shell-frame-guard';

if (!escapeShellFrame()) {
	import('./bootstrap')
		.catch(err => console.error(err));
}
